import Vue from 'vue'
import App from './components/App/App'
import router from './router'


import { tabfocusoutline } from 'tivigi/src/util/tabfocusoutline'
import * as pf from "tivigi/src/util/proxyfetch"
import "tivigi/src/util/vueFilters"

// Import global app-specific styles:
import "./globals.scss"



// Configure proxy url:
//pf.config.proxyUrl = "https://metropolatlas.digitale-mrn.de/proxy.php?csurl="

pf.config.proxyUrl = "https://metropolatlas.digitale-mrn.de/proxy.php?csurl="




// Enable tab focus outline:
tabfocusoutline()


// ATTENTION: We must register RemoteTemplateComponent as a global component in order to
// be able to use it in DynamicComponent. For some reason (recursion?) it doesn't work if
// we import/register it "locally" like other components.
Vue.component('RemoteTemplateComponent',() => import('./components/RemoteTemplateComponent/RemoteTemplateComponent') )



// Instantiate Vue root component:
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')




// -1 means it is not IE, so okay...


function msieversion() {
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {
        var uA = navigator.userAgent;
        var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

        if (rE.exec(uA) != null) {
            rV = parseFloat(RegExp.$1);
        }
        /*check for IE 11*/
        else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            rV = 11;
        }
    }
    return rV;
}
